import { render, staticRenderFns } from "./AssignmentQuestions.vue?vue&type=template&id=6a4e7dd8"
import script from "./AssignmentQuestions.vue?vue&type=script&lang=js"
export * from "./AssignmentQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports